import { z } from "zod";
import { brandIdsSchema } from "../../_components/SITESEARCH/brandFilterSchema";
import { tagQuerySchema } from "@/lib/normalizeHashtag";

export const numberList = [24, 48];
export const sortList = ["related","new", "view", "rate", "sale", "lowprice", "highprice"];
export const productsCategoriesSearchParamsSchema = z.object({
  page: z.coerce.number().default(0),
  search: z.coerce.string().optional().nullable().default(null),
  limit: z.coerce
    .number()
    .refine((value) => numberList.includes(value))
    .default(10),
  sort: z.coerce
    .string()
    .refine((value) => sortList.includes(value))
    .optional(),
  tag: tagQuerySchema,
  filter: z
    .object({
      colors: z
        .array(
          z.union([
            z.string().transform((val) => Number(val)), // Convert string numbers to numbers
            z.number(), // Accept numbers directly
          ]),
        )
        .optional(),
      brands: brandIdsSchema,
      hasOffer: z.coerce.boolean().optional().nullable(),
      inStock: z.coerce.boolean().optional().nullable(),
      minPrice: z.coerce.number().min(0).optional().nullable(),
      maxPrice: z.coerce.number().min(0).optional().nullable(),
    })
    .optional()
    .transform((data) => {
      if (data?.minPrice != null && data?.maxPrice != null) {
        if (data.maxPrice < data.minPrice) {
          data.maxPrice = null; // تنظیم maxPrice به null اگر کمتر از minPrice باشد
        } else if (data.minPrice > data.maxPrice) {
          data.minPrice = null; // تنظیم minPrice به null اگر بیشتر از maxPrice باشد
        }
      }
      return data;
    }),
});

export type ProductsCategoriesSearchParamsSchema = z.infer<typeof productsCategoriesSearchParamsSchema>;

export const productsCategoriesSearchParamsSchemaDefaults: ProductsCategoriesSearchParamsSchema = {
  page: 1,
  search: null,
  limit: numberList[0],
  sort: "related",
};
